import { createSelector } from "reselect";
import { getters } from "SendEmailModal/model";
import { MODES, MESSAGE_WYSIWYG_EDITOR_FIELD_ID } from "./constants";
import * as R from "ramda";
import * as SEND_TO_OPTION_TYPES from "SendEmailModal/utils/send-to-option-types";

import { getters as FormGetters } from "ui-kit/Form/model";

export const getMessage = createSelector(
  state => FormGetters.fields(state, { instanceId: undefined }),
  fields => {
    return fields[MESSAGE_WYSIWYG_EDITOR_FIELD_ID]
      ? fields[MESSAGE_WYSIWYG_EDITOR_FIELD_ID].value
      : null;
  }
);

export const getIsCurrentStateValid = createSelector(
  getters.mode,
  getters.activeStepIndex,
  getMessage,
  getters.subject,
  getters.selectedOptions,
  getters.messagePreviews,
  (
    mode,
    activeStepIndex,
    message,
    subject,
    selectedOptions,
    messagePreviews
  ) => {
    switch (activeStepIndex) {
      case 0:
        if (mode === MODES.SMS) {
          return message && message.length && selectedOptions;
        }
        return message && message.length && subject.length && selectedOptions;
      case 1:
        if (mode === MODES.SMS) {
          return Boolean(
            messagePreviews.filter(r => r.meta.hasValidPhone).length
          );
        }
        return Boolean(
          messagePreviews.filter(r => r.meta.hasValidEmail).length
        );

      default:
        return true;
    }
  }
);

export const getUniquePreviewMetaId = createSelector(
  getters.messagePreviews,
  messagePreviews => [
    ...new Map(messagePreviews?.map(item => [item?.meta?.id, item])).values()
  ]
);

export const formattedContactsSelected = createSelector(
  getters.particularContactsSelected,
  particularContactsSelected =>
    R.compose(
      R.sortBy(R.prop("label")),
      R.map(contact => ({
        value: contact.id,
        label: contact.email
      })),
      R.filter(R.propEq("selected", true))
    )(particularContactsSelected)
);

export const disableEmailsLogic = createSelector(
  getters.particularContactsSelected,
  getters.selectedOptions,
  (particularContactsSelected, selectedOptions) => {
    if (selectedOptions === SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS) {
      return (
        R.compose(
          R.length,
          R.filter(R.propEq("selected", true))
        )(particularContactsSelected) === 0
      );
    }
    return false;
  }
);

export const getCountOfEmailSenders = createSelector(
  getters.particularContactsSelected,
  particularContactsSelected =>
    R.compose(
      R.length,
      R.filter(R.propEq("selected", true))
    )(particularContactsSelected)
);

export const particularContactsSelectedArray = createSelector(
  getters.particularContactsSelected,
  R.filter(R.propEq("selected", true))
);

export const getParticularContactsSelectedIds = createSelector(
  particularContactsSelectedArray,
  R.map(R.prop("id"))
);
